<template>
  <div v-if="this.currentMasonryHeight" class="w-[90vw] max-w-[1180px] mx-auto my-2 sm:my-3 md:my-5 lg:my-6">
    <div class="flex justify-end min-h-[65px] transition-all duration-1000 shadow-md bg-center bg-cover p-[20px] border-t-[3px] relative transfade rounded-l-md overflow-hidden" :style="{height: (this.windowWidth * .95) >= 1140 ? 150 + 'px' : ((this.windowWidth * .95) / 1140) * 150 + 'px', 'border-color' : this.getColor}">
      <Transition name="fade">
        <div v-bind:key="this.sliderImages[this.currentSliderImageID]" :style="{ backgroundImage: 'url(' + this.sliderImages[this.currentSliderImageID] + ')' }" class="absolute top-0 bottom-0 left-0 right-0 bg-cover bg-center"></div>
      </Transition>
      <div class="absolute w-full h-full top-0 left-0 right-0 bottom-0 white-gradient md:white-gradient-desktop"></div>
      <svg v-if="this.getColor" xmlns="http://www.w3.org/2000/svg" class="w-[15vw] h-auto max-h-[70px] max-w-[160px] absolute left-3 md:left-auto md:right-6 top-[50%] translate-y-[-50%] z-50" viewBox="0 0 581.9 276.8"><path d="M22.1 143.2H0V0h22.1v82.8l12.5-1.2 23.9-39.5h24.7L54 89.4l30.8 53.8H59.9l-24.7-42.7-13.1 1.5v41.2zm78.9 0V42.1h21.9v12.1c11.5-7.4 22.9-12.2 34.4-14.4v22.1c-11.6 2.3-21.5 5.3-29.7 8.9l-4.5 1.8v70.6H101zM245.2 125l5.7-.6.4 16.4c-15.4 3.1-29 4.7-40.9 4.7-15 0-25.7-4.1-32.3-12.3-6.5-8.2-9.8-21.4-9.8-39.5 0-35.9 14.6-53.8 43.9-53.8 28.3 0 42.5 15.4 42.5 46.3l-1.4 15.8h-62.7c.1 8.4 2 14.5 5.5 18.4s10 5.9 19.6 5.9 19.4-.5 29.5-1.3zm-12.1-40c0-10-1.6-17-4.8-20.9-3.2-4-8.5-6-16.1-6s-13 2.1-16.5 6.3c-3.4 4.2-5.2 11.1-5.4 20.6h42.8zm117.7-11.8v46.1c.1 3 .9 5.2 2.3 6.6s3.6 2.3 6.6 2.7l-.6 16.8c-11.6 0-20.6-2.5-26.9-7.5-10.8 5-21.6 7.5-32.6 7.5-20.1 0-30.1-10.7-30.1-32.2 0-10.2 2.7-17.7 8.2-22.3s13.9-7.4 25.2-8.3l26.1-2.2v-7.3c0-5.4-1.2-9.2-3.5-11.3-2.4-2.2-5.8-3.2-10.4-3.2-8.6 0-19.4.5-32.4 1.6l-6.5.4-.8-15.6c14.7-3.5 28.2-5.3 40.6-5.3s21.2 2.7 26.7 8c5.4 5.5 8.1 13.9 8.1 25.5zm-45.3 25.1c-9.3.8-14 5.9-14 15.2s4.1 14 12.3 14c6.7 0 13.9-1.1 21.4-3.2l3.6-1.2v-27l-23.3 2.2zM433 60.9h-28v44.5c0 8.2.6 13.7 1.8 16.4s4.3 4 9.3 4l16.6-.6 1 17.6c-9 1.8-15.9 2.6-20.6 2.6-11.5 0-19.3-2.6-23.6-7.9s-6.4-15.2-6.4-29.7V60.9h-12.9V42.1h12.9V12.7H405V42h28v18.9zm18-36V1.6h22v23.3h-22zm0 118.3V42.1h22v101.2l-22-.1zm39.2-101.1h23.1l19.4 82.3h6.5l20.2-82.3h22.5l-26.3 101.2h-39.3L490.2 42.1zM146 275.1h-16.5v-75.6h16.3v4.7c7.2-4.2 13.7-6.3 19.6-6.3 8.8 0 15.2 2.5 19.2 7.4 9.2-4.9 18.3-7.4 27.4-7.4s15.5 2.8 19.2 8.4 5.6 15 5.6 28.3v40.5h-16.3v-40c0-8.2-.8-14-2.5-17.4s-5.1-5.1-10.4-5.1c-4.5 0-9.4 1-14.7 3l-2.6 1.1c.8 2 1.2 8.5 1.2 19.3v39.1h-16.3v-38.8c0-9-.8-15.2-2.4-18.6s-5.1-5.1-10.6-5.1c-5 0-9.7 1-14.1 3l-2.3.9v58.6h.2zm114.3-67.4c5.2-6.5 13.8-9.8 25.9-9.8s20.7 3.3 25.9 9.8c5.2 6.6 7.8 16.4 7.8 29.5s-2.5 23-7.6 29.6c-5 6.6-13.8 10-26.1 10s-21.1-3.3-26.1-10c-5-6.6-7.6-16.5-7.6-29.6s2.6-22.9 7.8-29.5zm12.3 49.1c2.3 4 6.9 6 13.6 6s11.3-2 13.6-6 3.5-10.6 3.5-19.8-1.2-15.7-3.7-19.5-6.9-5.7-13.4-5.7c-6.4 0-10.9 1.9-13.4 5.7s-3.7 10.3-3.7 19.5c.1 9.2 1.2 15.8 3.5 19.8zm98.9-58.9c10.4 0 17.9 2.9 22.4 8.7 4.6 5.8 6.9 16 6.9 30.8 0 14.7-2.7 25-8.2 30.8-5.4 5.8-15 8.7-28.7 8.7-4.7 0-12.2-.5-22.5-1.4l-5.1-.5V168.1h16.3v34.3c6.9-3 13.2-4.5 18.9-4.5zm-7.6 64.2c8.1 0 13.4-1.9 16.1-5.7s4-10.2 4-19.3-1.1-15.4-3.4-19.1-6-5.5-11.1-5.5c-4.8 0-9.7.8-14.5 2.3l-2.4.8v45.9c5.5.4 9.3.6 11.3.6zm24.4-75.4v-17.4h16.5v17.4h-16.5zm29 88.4v-75.6h16.5v75.6h-16.5zm37.3 0v-107h16.5v107h-16.5z"/><circle cx="546.4" cy="240.6" r="34.5" class="transition-all duration-1000" :style="'fill:' + this.getColor"/></svg>
      <button type="button" aria-label="Menü öffnen" @click="menuOpen = true" class="md:hidden bg-white absolute right-3 top-[50%] translate-y-[-50%] z-50 p-2 rounded-md text-zinc-800 hover:bg-black/10 transition-colors" style="filter: drop-shadow(0 1px 3px rgba(0,0,0,0.3));">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path stroke="none" d="M0 0h24v24H0z"/><path d="M4 6h16M4 12h16M4 18h16"/></svg>
      </button>
    </div>
    <Transition name="slide">
      <div v-if="menuOpen" class="fixed inset-0 z-[200] bg-white/95 flex flex-col justify-center items-center gap-4 p-6 md:hidden" role="dialog" aria-modal="true" aria-label="Navigation">
        <button type="button" aria-label="Menü schließen" @click="menuOpen = false" class="absolute top-4 right-4 p-2 text-zinc-600 hover:bg-zinc-200 rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke="none" d="M0 0h24v24H0z"/><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
        <a @click.prevent="menuOpen = false; $router.push('/')" href="#" class="w-full max-w-[280px] py-3 px-4 rounded-lg text-center font-medium text-white shadow-md transition-opacity" style="background-color: #930023">Kurse</a>
        <a @click.prevent="menuOpen = false; $router.push('/werke/eigene')" href="#" class="w-full max-w-[280px] py-3 px-4 rounded-lg text-center font-medium text-white shadow-md" style="background-color: #8970ea">Meine Werke</a>
        <a @click.prevent="menuOpen = false; $router.push('/werke/teilnehmer')" href="#" class="w-full max-w-[280px] py-3 px-4 rounded-lg text-center font-medium text-white shadow-md" style="background-color: #1289A7">Eure Werke</a>
        <a @click.prevent="menuOpen = false; $router.push('/about')" href="#" class="w-full max-w-[280px] py-3 px-4 rounded-lg text-center font-medium text-white shadow-md" style="background-color: #e28e18">Über mich</a>
        <a @click.prevent="menuOpen = false; $router.push('/videos')" href="#" class="w-full max-w-[280px] py-3 px-4 rounded-lg text-center font-medium text-white shadow-md" style="background-color: #A3CB38">Videos</a>
        <a @click.prevent="menuOpen = false; $router.push('/impressum')" href="#" class="w-full max-w-[280px] py-3 px-4 rounded-lg text-center font-medium text-white shadow-md" style="background-color: #c44569">Impressum</a>
      </div>
    </Transition>
    <div class="hidden md:flex justify-between relative my-3">
      <div @click="this.$router.push('/')" :class="{ 'bg-[#930023]': this.site == 'homepage',  'bg-zinc-500' : this.site != 'homepage' }" class= "lg:rounded-sm w-[23%] min-w-[23%] max-w-[23%] md:w-[15.5%] lg:w-[15%] lg:min-w-[15%] lg:max-w-[15%] md:min-w-[15.5%] md:max-w-[15.5%] pb-[23%] md:pb-[15.5%] lg:pb-[15%] block relative shadow-material opacity-80 hover:opacity-90 cursor-pointer hover:bg-[#930023] transition-all duration-500 rounded-l-md rounded-r-md flex items-center justify-center md:justify-start text-white text-xs md:text-sm lg:text-base tracking-wider font-normal">
        <img class="absolute top-[35%] left-[50%] translate-y-[-50%] translate-x-[-50%] icon opacity-90 w-[45%] h-auto" :src="require('./../assets/icon-courses.png')" alt="Kurse" />
        <span class=" absolute left-[50%] bottom-[10%] md:bottom-[10%] lg:bottom-[13%] translate-x-[-50%] text-center w-[90%]">
          <span class="text-[10px] min-h-[22px] md:min-h-[37px] lg:min-h-[25px] inline-flex items-center inline-block leading-[1.1] md:leading-[1.1] md:text-base lg:text-xl font-light">Kurse</span><br />
          <div class="text-xs tracking-normal hidden">Akt. Kurse und Termine</div>
        </span>
      </div>
      <div @click="this.$router.push('/werke/eigene')" :class="{ 'bg-[#8970ea]': this.site == 'eigene-werke',  'bg-zinc-500' : this.site != 'eigene-werke' }" class= "lg:rounded-sm w-[23%] min-w-[23%] max-w-[23%] md:w-[15.5%] lg:w-[15%] lg:min-w-[15%] lg:max-w-[15%] md:min-w-[15.5%] md:max-w-[15.5%] pb-[23%] md:pb-[15.5%] lg:pb-[15%] block relative shadow-material opacity-80 hover:opacity-90 cursor-pointer hover:bg-[#8970ea] transition-all duration-500 rounded-l-md rounded-r-md flex items-center justify-center md:justify-start hidden md:block text-white text-xs md:text-sm lg:text-base tracking-wider font-normal">
        <img class="absolute top-[35%] left-[50%] translate-y-[-50%] translate-x-[-50%] icon opacity-90 w-[45%] h-auto" :src="require('./../assets/icon-images-intern.png')" alt="Kurse" />
        <span class=" absolute left-[50%] bottom-[10%] md:bottom-[10%] lg:bottom-[13%] translate-x-[-50%] text-center w-[90%]">
          <span class="text-[10px] min-h-[22px] md:min-h-[37px] lg:min-h-[25px] inline-flex items-center inline-block leading-[1.1] md:leading-[1.1] md:text-base lg:text-xl font-light">Meine Werke</span><br />
          <div class="text-xs tracking-normal hidden">Auswahl eigener Werke</div>
        </span>
      </div>
      <div @click="this.$router.push('/werke/teilnehmer')" :class="{ 'bg-[#1289A7]': this.site == 'teilnehmer-werke',  'bg-zinc-500' : this.site != 'teilnehmer-werke' }" class= "lg:rounded-sm w-[23%] min-w-[23%] max-w-[23%] md:w-[15.5%] lg:w-[15%] lg:min-w-[15%] lg:max-w-[15%] md:min-w-[15.5%] md:max-w-[15.5%] pb-[23%] md:pb-[15.5%] lg:pb-[15%] block relative shadow-material opacity-80 hover:opacity-90 cursor-pointer hover:bg-[#1289A7] transition-all duration-500 rounded-l-md rounded-r-md flex items-center justify-center md:justify-start text-white text-xs md:text-sm lg:text-base tracking-wider font-normal">
        <img class="absolute top-[35%] left-[50%] translate-y-[-50%] translate-x-[-50%] icon opacity-90 w-[45%] h-auto" :src="require('./../assets/icon-images-extern.png')" alt="Kurse" />
        <span class=" absolute left-[50%] bottom-[10%] md:bottom-[10%] lg:bottom-[13%] translate-x-[-50%] text-center w-[90%]">
          <span class="text-[10px] min-h-[22px] md:min-h-[37px] lg:min-h-[25px] inline-flex items-center inline-block leading-[1.1] md:leading-[1.1] md:text-base lg:text-xl font-light">Eure Werke</span><br />
          <div class="text-xs tracking-normal hidden">Werke der Teilnehmer</div>
        </span>
      </div>
      <div @click="this.$router.push('/about')" :class="{ 'bg-[#e28e18]': this.site == 'about',  'bg-zinc-500' : this.site != 'about' }" class= "lg:rounded-sm w-[23%] min-w-[23%] max-w-[23%] md:w-[15.5%] lg:w-[15%] lg:min-w-[15%] lg:max-w-[15%] md:min-w-[15.5%] md:max-w-[15.5%] pb-[23%] md:pb-[15.5%] lg:pb-[15%] block relative shadow-material opacity-80 hover:opacity-90 cursor-pointer hover:bg-[#e28e18] transition-all duration-500 rounded-l-md rounded-r-md flex items-center justify-center md:justify-start text-white text-xs md:text-sm lg:text-base tracking-wider font-normal">
        <img class="absolute top-[35%] left-[50%] translate-y-[-50%] translate-x-[-50%] icon opacity-90 w-[45%] h-auto" :src="require('./../assets/icon-about.png')" alt="Kurse" />
        <span class=" absolute left-[50%] bottom-[10%] md:bottom-[10%] lg:bottom-[13%] translate-x-[-50%] text-center w-[90%]">
          <span class="text-[10px] min-h-[22px] md:min-h-[37px] lg:min-h-[25px] inline-flex items-center inline-block leading-[1.1] md:leading-[1.1] md:text-base lg:text-xl font-light">Über mich</span><br />
          <div class="text-xs tracking-normal hidden">Gabriela Macke</div>
        </span>
      </div>
      <div @click="this.$router.push('/videos')" :class="{ 'bg-[#A3CB38]': this.site == 'videos',  'bg-zinc-500' : this.site != 'videos' }" class= "lg:rounded-sm w-[23%] min-w-[23%] max-w-[23%] md:w-[15.5%] lg:w-[15%] lg:min-w-[15%] lg:max-w-[15%] md:min-w-[15.5%] md:max-w-[15.5%] pb-[23%] md:pb-[15.5%] lg:pb-[15%] hidden md:block relative shadow-material opacity-80 hover:opacity-90 cursor-pointer hover:bg-[#A3CB38]  transition-all duration-500 rounded-l-md rounded-r-md flex items-center justify-center md:justify-start text-white text-xs md:text-sm lg:text-base tracking-wider font-normal">
        <img class="absolute top-[35%] left-[50%] translate-y-[-50%] translate-x-[-50%] icon opacity-90 w-[45%] h-auto" :src="require('./../assets/icon-shop.png')" alt="Videos" />
        <span class=" absolute left-[50%] bottom-[10%] md:bottom-[10%] lg:bottom-[13%] translate-x-[-50%] text-center w-[90%]">
          <span class="text-[10px] min-h-[22px] md:min-h-[37px] lg:min-h-[25px] inline-flex items-center inline-block leading-[1.1] md:leading-[1.1] md:text-base lg:text-xl font-light">Videos</span><br />
          <div class="text-xs tracking-normal hidden">Video-Archiv</div>
        </span>
      </div>
      <div @click="this.$router.push('/impressum')" :class="{ 'bg-[#c44569]': this.site == 'impressum',  'bg-zinc-500' : this.site != 'impressum' }" class= "lg:rounded-sm w-[23%] min-w-[23%] max-w-[23%] md:w-[15.5%] lg:w-[15%] lg:min-w-[15%] lg:max-w-[15%] md:min-w-[15.5%] md:max-w-[15.5%] pb-[23%] md:pb-[15.5%] lg:pb-[15%] relative shadow-material opacity-80 hover:opacity-90 cursor-pointer hover:bg-[#c44569] transition-all duration-500 rounded-l-md rounded-r-md flex items-center justify-center md:justify-start text-white text-xs md:text-sm lg:text-base tracking-wider font-normal">
        <img class="absolute top-[35%] left-[50%] translate-y-[-50%] translate-x-[-50%] icon opacity-90 w-[45%] h-auto" :src="require('./../assets/icon-legal2.png')" alt="Kurse" />
        <span class=" absolute left-[50%] bottom-[10%] md:bottom-[10%] lg:bottom-[13%] translate-x-[-50%] text-center w-[90%]">
          <span class="text-[10px] min-h-[22px] md:min-h-[37px] lg:min-h-[25px] inline-flex items-center inline-block leading-[1.1] md:leading-[1.1] md:text-base lg:text-xl font-light">Impressum</span><br />
          <div class="text-xs tracking-normal hidden">Impressum</div>
        </span>
      </div>
    </div>
    <div v-if="this.site == 'homepage'">
      <div class="my-6 shadow-md rounded-l-md overflow-hidden" v-for="(course, index) in this.courses" :key="index">
        <div class="flex flex-wrap justify-between border-b-[3px] border-b-zinc-400 p-4 md:py-8 md:px-6 lg:px-8 bg-zinc-200">
          <div class="flex flex-col w-[100%] md:w-[72%]">
            <div class="flex justify-start">
              <div class="flex flex-grow flex-col">
                <div class="text-xs md:text-base text-zinc-400 lg:text-[17px] xl:text-lg">{{ course.dates.length == 1 ? 'Einmaliger Kurs | 1 Termin' : 'Serienkurs | ' + course.dates.length + ' Termine' }}</div>
                <div class="text-base md:text-xl lg:text-[27px] xl:text-3xl text-zinc-700 font-light leading-[1.25] md:leading-7 mb-1 pb-3 max-w-[265px] md:max-w-full">{{ course.title }}</div>
              </div>
            </div>
            <div class="flex flex-col-reverse md:flex-row justify-start">
              <div class="flex flex-grow flex-col md:pr-3 lg:pr-6">
                <div class="text-xs md:text-[13.3px] lg:text-[14px] text-zinc-700 font-normal leading-5 md:leading-[1.65] my-3"> {{ course.description }} </div>
                <div v-if="course.dateinfo.length != 0" class="text-xs md:text-[13.3px] text-zinc-700 font-normal leading-5 md:leading-5 max-w-[340px]">{{ course.dateinfo }}</div>
              </div>
              <div class="flex flex-col items-start justify-start flex-grow my-2 md:mb-0 md:mt-4 w-[38%] min-w-full md:min-w-[285px]">
                <div class="bg-zinc-300 rounded-md shadow-sm px-4 py-2 flex flex-col justify-center w-full">
                  <div class="text-xs text-zinc-700 font-light">Nächster Termin:</div>
                  <div class="text-xs md:text-base text-zinc-900 font-normal" v-html="sanitize(course.nextDate)"></div>
                  <TransitionExpand><div v-if="typeof course.showalldates != 'undefined' && course.showalldates == true" class="text-[13.6px] leading-5 my-1 text-zinc-600 font-light" v-html="sanitize(this.renderAllDates(index))"></div></TransitionExpand>
                  <div @click="course.showalldates = typeof course.showalldates == 'undefined' ? true : !course.showalldates; course.showpriceinfo = false" class="inline-flex mt-0.5 cursor-pointer items-center rounded bg-transparent px-[2px] py-[2px] text-[13.6px] font-normal underline text-zinc-600">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="mr-1 icon icon-tabler icon-tabler-click" viewBox="0 0 24 24"><path stroke="none" d="M0 0h24v24H0z"/><path d="M3 12h3M12 3v3M7.8 7.8 5.6 5.6M16.2 7.8l2.2-2.2M7.8 16.2l-2.2 2.2M12 12l9 3-4 2-2 4-3-9"/></svg>
                    Terminübersicht {{ typeof course.showalldates == 'undefined' ? 'anzeigen' : course.showalldates ? 'verstecken' : 'anzeigen' }}
                  </div>
                </div>
                <div class="bg-zinc-300 rounded-md shadow-sm px-4 mt-4 py-2 flex flex-col justify-center w-full">
                  <div class="text-xs md:text-base text-zinc-900 font-normal">Preis: {{ course.price }} / p.P.</div>
                  <TransitionExpand><div v-if="typeof course.showpriceinfo != 'undefined' && course.showpriceinfo == true" class="text-[13.6px] leading-[1.25] my-1 text-zinc-600 font-light"> {{ course.infotext }} </div></TransitionExpand>
                  <div @click="course.showpriceinfo = typeof course.showpriceinfo == 'undefined' ? true : !course.showpriceinfo; course.showalldates = false" class="inline-flex mt-0.5 cursor-pointer items-center rounded bg-transparent px-[2px] py-[2px] text-[13.6px] font-normal underline text-zinc-600">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="mr-1 icon icon-tabler icon-tabler-click" viewBox="0 0 24 24"><path stroke="none" d="M0 0h24v24H0z"/><path d="M3 12h3M12 3v3M7.8 7.8 5.6 5.6M16.2 7.8l2.2-2.2M7.8 16.2l-2.2 2.2M12 12l9 3-4 2-2 4-3-9"/></svg>
                    Preisinfo {{ typeof course.showpriceinfo == 'undefined' ? 'anzeigen' : course.showpriceinfo ? 'verstecken' : 'anzeigen' }}
                  </div>
                </div>
                <div class="flex justify-between mt-4 w-[280px] md:max-w-full md:w-full">
                  <a target="_blank" :href="course.registration.online" class="inline-flex flex-col items-start leading-[1] rounded-md border border-transparent bg-[#9F2439] px-3.5 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-[#8c1e31] focus:outline-none focus:ring-2 focus:ring-[#9F2439] focus:ring-offset-2">
                    <span class="text-xs">Familienbildungsst.</span>
                    <span>Online anmelden</span>
                  </a>
                  <a target="_blank" :href="'tel:' + course.registration.phone" class="inline-flex flex-col items-start leading-[1] rounded-md border border-transparent bg-[#9F2439] px-3.5 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-[#8c1e31] focus:outline-none focus:ring-2 focus:ring-[#9F2439] focus:ring-offset-2">
                    <span class="text-xs">{{ course.registration.phone }}</span>
                    <span>Tel. Rückfragen</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col mt-4 md:mt-0 w-[100%] md:w-[26%] min-h-full">
            <div class="min-h-full h-[250px]" v-if="course.geodata">
              <l-map ref="map" :zoom="15" :center="[course.geodata.lat, course.geodata.lng]" class="h-[250px] min-h-full relative overflow-hidden rounded-md shadow-md">
                <l-tile-layer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" :attribution="osmAttribution" @ready="enableOsmReferrer" />
                <l-marker :lat-lng="[course.geodata.lat, course.geodata.lng]">
                  <l-popup>
                    <p><strong>Veranstaltungsort:</strong></p>
                    <div v-html="sanitize(course.address.split(',').join('<br />'))"></div>
                    <p class="mt-1"><a class="text-[#9F2439]" target="_blank" rel="noopener noreferrer" :href="'https://www.openstreetmap.org/search?query=' + encodeURIComponent(course.address)">Route planen</a></p>
                  </l-popup>
                </l-marker>
              </l-map>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4.5 lg:mt-8 mb-8" v-if="(this.site == 'eigene-werke' || this.site == 'teilnehmer-werke') && this.images && this.images.length != 0 && this.lightboxItems && this.lightboxItems.length != 0">
      <vue-easy-lightbox :visible="this.visibleRef" :imgs="this.lightboxItems" :index="this.indexRef" @hide="onHide"></vue-easy-lightbox>
      <h1 class="text-xl lg:text-3xl font-light pl-2 my-3.5 lg:my-6">{{ this.site == 'eigene-werke' ? 'Auswahl meiner Werke (' + this.filesTotal + ')' : 'Werke meiner Teilnehmer (' + this.filesTotal + ')' }}</h1>
      <div>
        <MasonryWall class="images-wrapper" :items="this.images" :ssr-columns="0" :column-width="this.renderedGridWidth" :gap="1140 * .02">
          <template #default="{ item, index }">
            <div :style="{ height: (item.dimensions.height / item.dimensions.width) * this.renderedGridWidth + 'px' }" class="pic relative">
              <img @click="() => this.showImg(index)" class="h-full image align-middle w-full cursor-pointer" :src="'/files/' + item._id + '/small'" />
              <div :ref="'likebox' + index" @click="this.sendLike(item._id, index)" :class="{ liked : item.liked == true }" class="like-box absolute transition-all duration-200 bg-[rgba(255,255,255,.65)] p-1.5 rounded-lg hover:bg-white absolute right-3 bottom-3 cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="relative transition-all duration-300 z-10 icon icon-tabler icon-tabler-heart" viewBox="0 0 24 24"><path stroke="none" d="M0 0h24v24H0z"/><path class="transition-all duration-300 heart" fill="#fff" d="M19.5 12.572 12 20l-7.5-7.428m0 0A5 5 0 1 1 12 6.006a5 5 0 1 1 7.5 6.572"/></svg>
                <div class="absolute bg-white py-1.5 px-2.5 text-lg translate-y-[-50%] font-light top-[50%] rounded-l-lg transition-all duration-300 right-0 opacity-0">{{ item.score }}</div>
              </div>
            </div>
          </template>
        </MasonryWall>
      </div>
      <InfiniteLoading class="opacity-0 h-[0] overflow-hidden" :key="this.site" @infinite="this.infiniteHandler" />
    </div>
    <div class="mt-4.5 lg:mt-8 mb-8" v-if="this.site == 'about'">
      <div class="flex flex-wrap justify-between">
        <div class="w-full md:w-[60%] lg:w-[62%] border-b-[3px] border-b-zinc-400 p-4 md:py-8 md:px-6 lg:px-8 bg-zinc-200 md:rounded-l-md leading-[1.5] text-zinc-700 font-light shadow-md">
          <h1 class="text-xl lg:text-3xl font-light mb-3.5 lg:mb-6">Über mich</h1>
          <p class="mb-4">1956 in Wien geboren, habe ich mich bereits als Kind und junge Frau mit Unterstützung meines Vaters, der Musiker war, mit Kunst in verschiedensten Formen beschäftigt. Das Malen und Zeichnen war für mich immer Herausforderung und Entspannung zu gleichen Teilen. Sowohl in Studiengängen, autodidakt sowie in Workshops und Bildungsurlauben habe ich mich stetig weiter entwickelt, wobei die Veröffentlichung meiner Bilder dabei nie im Fokus stand.</p>
          <p class="mb-4">Realismus und Impressionismus haben mich in frühen Jahren besonders fasziniert. Heute verschwimmen die Stile in meiner Arbeit und ich male nur mehr was mir Freude macht. Ich versuche mich von gegenständlicher Malerei zu lösen und sowohl impressionistisch wie auch intuitiv zu malen.</p>
          <p class="mb-8">Durch meine nebenberufliche Betätigung in div. Ehrenämtern habe ich erfahren, wie wichtig es ist neben Partner:in, Kindern und Beruf, einen Ausgleich zu schaffen. Diese Erfahrungen waren vor Jahrzehnten die Initialzündung zur Gründung von kreativ mobil und zum Angebot meiner Kurse in intuitivem Malen. Es ist mir ein besonderes Anliegen, Menschen jeden Alters die Gelegenheit zu bieten, durch Intuitives Malen zu innerer Kraft, Ruhe, Freude und Gelassenheit zu finden.</p>
          <img class="max-w-[250px]" :src="require('./../assets/gmacke_signatur.png')" alt="Gabriela Macke" />
        </div>
        <div class="w-full md:w-[38%] lg:w-[36%] md:self-start">
          <img class="shadow-md w-full h-auto rounded-md" :src="require('./../assets/gmacke_large.jpg')" alt="Gabriela Macke" />
        </div>
      </div>
    </div>
    <div class="mt-4.5 lg:mt-8 mb-8" v-if="this.site == 'impressum'">
      <div class="flex flex-wrap justify-between">
        <div class="w-full border-b-[3px] border-b-zinc-400 p-4 md:py-8 md:px-6 lg:px-8 bg-zinc-200 md:rounded-l-md leading-[1.5] text-zinc-700 font-light shadow-md">
          <h1 class="text-xl lg:text-3xl font-light mb-3.5 lg:mb-6">Impressum</h1>
          <div class='impressum'>
            <p>Angaben gemäß § 5 TMG</p><p>Gabriela Macke <br>
            Auenweg 26<br>
            53797 Lohmar <br><br>
          </p><p> <strong>Vertreten durch: </strong><br>
            Gabriela Macke<br><br>
          </p><p><strong>Kontakt:</strong> <br>
            Telefon: +49 1577 3194112<br>
            E-Mail: <a href='mailto:gmacke234@outlook.com'>gmacke234@outlook.com</a></p><p>
            <br>
            <strong class="text-lg">Haftungsausschluss: </strong><br><br><strong>Haftung für Inhalte</strong><br><br>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.<br><br><strong>Haftung für Links</strong><br><br>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.<br><br><strong>Urheberrecht</strong><br><br>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.<br><br><strong>Datenschutz</strong><br><br>
            Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben. <br><br>
            Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. <br><br>
            Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.<br>
          </p><br>
            Impressum vom <a target="_blank" href="https://www.impressum-generator.de">Impressum Generator</a> der <a href="https://www.kanzlei-hasselbach.de/standorte/frankfurt/" rel="nofollow">Kanzlei Hasselbach, Frankfurt</a> </div>
        </div>
      </div>
    </div>
    <div class="mt-4.5 lg:mt-8 mb-8" v-if="this.site == 'videos'">
      <h1 class="text-xl lg:text-3xl font-light pl-2 my-3.5 lg:my-6">Videos</h1>
      <div class="bg-zinc-200 rounded-lg shadow-md p-4 md:p-6 lg:p-8 mb-6 max-w-[1180px]">
        <p class="text-zinc-700 leading-relaxed">
          In meinen Kursen zum Intuitiven Malen geht es darum, zur Ruhe zu kommen, sich ohne Bewertung auszudrücken und im Gestalten anzukommen. Dazu sind begleitende Videos geplant: So können Sie das Intuitive Malen auch zu Hause für sich entdecken und vertiefen – passend zu den Themen aus den Kursen.
        </p>
      </div>
      <div v-if="videos.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div v-for="v in videos" :key="v._id" class="bg-zinc-200 rounded-lg overflow-hidden shadow-md">
          <div class="aspect-video bg-black">
            <iframe :src="'https://www.youtube-nocookie.com/embed/' + v.youtubeId + '?rel=0'" :title="v.title" referrerpolicy="strict-origin-when-cross-origin" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="w-full h-full"></iframe>
          </div>
          <div class="p-4">
            <h2 class="text-lg font-medium text-zinc-800">{{ v.title }}</h2>
            <p v-if="v.description" class="text-sm text-zinc-600 mt-1">{{ v.description }}</p>
          </div>
        </div>
      </div>
      <p v-else class="text-zinc-500 pl-2 text-lg font-light">Coming soon</p>
    </div>
    <div class="flex items-stretch flex-wrap-reverse">
      <div class="mb-6 bg-zinc-200 p-4 md:py-8 md:px-6 lg:px-8 flex-grow w-full md:w-auto md:mr-6 shadow-md">
        <div class="flex flex-wrap justify-start">
          <div class="md:mr-6 md:pr-6 mb-4 w-full md:w-auto md:border-zinc-300 md:border-r">
            <div class="text-xl mb-2 font-light">In Zusammenarbeit mit:</div>
            <a class="text-zinc-600 hover:text-zinc-700 block mb-1" target="_blank" href="https://bildung.erzbistum-koeln.de/fbs-bonn/index.html">Kath. Familienbildungsstätte Bonn</a>
            <a class="text-zinc-600 hover:text-zinc-700 block mb-1" target="_blank" rel="noopener noreferrer" href="https://www.lja.de/">Ev. Landjugendakademie Altenkirchen</a>
            <a class="text-zinc-600 hover:text-zinc-700 block mb-1" target="_blank" rel="noopener noreferrer" href="https://www.eutonie-kress.de/">Martina Kress · Praxis für Eutonie</a>
            <a class="text-zinc-600 hover:text-zinc-700 block mb-1" target="_blank" rel="noopener noreferrer" href="https://www.spree-heilpraktikerin.de/">Ulrike Spree · Praxis für Naturheilkunde</a>
          </div>
          <div class="mb-4">
            <div class="text-xl mb-2 font-light">Inhaltlich verantwortlich:</div>
            <div class="text-zinc-600 mb-1">Gabriela Macke</div>
            <div class="text-zinc-600 mb-1">Auenweg 26, 53797 Lohmar</div>
            <div class="text-zinc-600 mb-1">Tel.: +49 1577 3194112</div>
            <div class="text-zinc-600 mb-1"><a href="mailto:gmacke234@outlook.com">gmacke234@outlook.com</a></div>
          </div>
        </div>
        <hr class="block mb-6 mt-4 border-zinc-300" />
        <div class="text-lg font-light italic">
          „Verleihe meiner inneren Seele Schönheit; <br />
          mögen mein Äußeres und mein Inneres eins sein.“
        </div>
        <div class="font-light text-xs mt-1">Sokrates</div>
      </div>
      <div v-if="this.randomFiles && this.randomFiles.length != 0" class="w-full mb-6 md:max-w-[320px] bg-zinc-200 overflow-hidden p-4 shadow-md">
        <div class="mb-2 text-zinc-700 text-xl font-light">Zufällige Werke:</div>
        <div class="h-[270px] w-full relative overflow-hidden rounded-lg">
          <Transition name="fade">
            <div v-bind:key="this.randomFiles[this.currentRandomFileID]" :style="'background-image: url(/files/' + this.randomFiles[this.currentRandomFileID]._id + '/thumbnail)'" class="absolute top-0 bottom-0 left-0 right-0 bg-cover bg-center rounded-md"></div>
          </Transition>
          <div v-if="this.randomFiles[this.currentRandomFileID].author || this.randomFiles[this.currentRandomFileID].title" class="absolute bottom-0 left-0 right-0 rounded-b-md mx-[-2px] mb-[-2px] bg-[rgba(255,255,255,.85)] px-2.5 py-2">
            <div v-if="this.randomFiles[this.currentRandomFileID].author" class="text-xs">{{ this.randomFiles[this.currentRandomFileID].author }}</div>
            <div v-if="this.randomFiles[this.currentRandomFileID].title">{{ this.randomFiles[this.currentRandomFileID].title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div @click="this.scrollTop()" v-if="this.toTopActive" :style="{ 'background-color': this.getColor }" class="w-[40px] h-[40px] flex items-center justify-center text-white fixed bottom-[1.5rem] right-[1.3rem] cursor-pointer z-[250]">
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="icon icon-tabler icon-tabler-chevrons-up" viewBox="0 0 24 24"><path stroke="none" d="M0 0h24v24H0z"/><path d="m7 11 5-5 5 5M7 17l5-5 5 5"/></svg>
  </div>
</template>

<script>
import axios from 'axios';
import DOMPurify from 'isomorphic-dompurify';
import { LMap, LTileLayer, LMarker, LPopup } from '@vue-leaflet/vue-leaflet';
import TransitionExpand from '@/components/transitions/TransitionExpand';
import MasonryWall from '@yeger/vue-masonry-wall';
import VueEasyLightbox from 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min.js';
import 'vue-easy-lightbox/external-css/vue-easy-lightbox.css';
import { ref } from "vue";
import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css";

export default {
  name: 'WebsiteFrontend',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    TransitionExpand,
    MasonryWall,
    VueEasyLightbox,
    InfiniteLoading
  },
  props: {
    site: String
  },
  setup() {
    const visibleRef = ref(false)
    const indexRef = ref(0)
    const lightboxItems = []
    const showImg = (index) => {
      indexRef.value = index
      visibleRef.value = true
    }
    const onHide = () => visibleRef.value = false
    return {
      visibleRef,
      indexRef,
      lightboxItems,
      showImg,
      onHide
    }
  },
  data() {
    return {
      courses: [],
      images: [],
      filesTotal: 0,
      currentMasonryHeight: 800,
      lastSkipIndex: 0,
      busy: false,
      windowWidth: window.innerWidth,
      currentSliderImageID: 0,
      sliderInterval: 0,
      currentRandomFileID: 0,
      renderedGridWidth: 350,
      randomFiles: [],
      toTopActive: false,
      menuOpen: false,
      videoCount: 0,
      videos: [],
      osmAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      sliderImages: [
        require('./../assets/head_bg_01.jpg'),
        'https://images.pexels.com/photos/7233358/pexels-photo-7233358.jpeg?auto=compress&cs=tinysrgb&w=1140',
        require('./../assets/head_bg_02.jpg'),
      ]
    }
  },
  methods: {
    sanitize(html) {
      return DOMPurify.sanitize(html || '', { ALLOWED_TAGS: ['div', 'span', 'br', 'a', 'strong'] });
    },
    enableOsmReferrer(layer) {
      if (!layer || layer.options.referrerPolicy === 'strict-origin-when-cross-origin') return;
      layer.options.referrerPolicy = 'strict-origin-when-cross-origin';
      layer.redraw();
    },
    scrollTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    getVideoCount() {
      axios.get('/api/videos/count').then(res => { this.videoCount = parseInt(res.data, 10) || 0; }).catch(() => {});
    },
    getVideos() {
      axios.get('/api/videos').then(res => { this.videos = res.data; }).catch(() => {});
    },
    getRandomImages(status) {
      axios
          .get('/fileserver/random?status=' + status)
          .then((res) => {
            this.randomFiles = res.data;
          })
          .catch(() => {
          });
    },
    getCourses() {
      axios
          .get('/api/courses/get/all')
          .then((res) => {
            this.courses = res.data;
            this.courses.forEach((course, key) => {
              this.renderNextDate(key);
              const url = 'https://nominatim.openstreetmap.org/search?q=' + encodeURIComponent(course.address) + '&format=json&limit=1';
              axios.get(url, { headers: { 'Accept-Language': 'de', 'User-Agent': 'kreativ-mobil.com/1.0' } }).then((data) => {
                const r = data.data?.[0];
                if (r) this.courses[key].geodata = { lat: parseFloat(r.lat), lng: parseFloat(r.lon) };
              }).catch(() => {});
            });
          })
          .catch(() => {
          });
    },
    renderAllDates(ind) {
      let html = '';
      this.courses[ind].dates.forEach((date) => {
        html += '<div>' + String(new Date(date.start).getDate()).padStart(2, '0') + '.' + String(new Date(date.start).getMonth() + 1).padStart(2, '0') + '.' + String(new Date(date.start).getFullYear()).slice(-2) + ' | ' + String(new Date(date.start).getHours()).padStart(2, '0') + ':' + String(new Date(date.start).getMinutes()).padStart(2, '0') + ' - ' + String(new Date(date.end).getHours()).padStart(2, '0') + ':' + String(new Date(date.end).getMinutes()).padStart(2, '0') + ' Uhr</div>';
      });
      return html;
    },
    renderNextDate(index) {
      let today = new Date();
      async function callDateRender(courses, formatDate) {
        return await new Promise(resolve => {
          courses[index].dates.forEach((date, ind) => {
            let dateob = new Date(date.start);
            let dateStr = formatDate(dateob);
            if (dateob >= today) {
              let retString = `<span>${dateStr}</span>`;
              resolve([retString, (parseInt(ind) + 1) + ' / ']);
            }
            if ((ind + 1) == courses[index].dates.length) {
              let retString = `<span class="text-[#9F2439]">Alle Termine vergangen</span>`;
              resolve([retString, '']);
            }
          });
        });
      }
      callDateRender(this.courses, this.formatDate).then((ret) => {
        this.courses[index].nextDate = ret[0];
        this.courses[index].currentDate = ret[1];
      });
    },
    formatDate(date) {
      return String(date.getDayName()) + ', ' + String(date.getDate()).padStart(2, '0') + '.' + String(date.getMonth() + 1).padStart(2, '0') + '.' + String(date.getFullYear()).slice(-2) + ' - ' + String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0') + ' Uhr';
    },
    toggleImage: function(){
      if(this.currentSliderImageID < this.sliderImages.length-1){
        this.currentSliderImageID +=1
      } else {
        this.currentSliderImageID = 0
      }
    },
    toggleFile: function(){
      if(this.currentRandomFileID < this.randomFiles.length-1){
        this.currentRandomFileID +=1
      } else {
        this.currentRandomFileID = 0
      }
    },
    getFiles(skipIndex) {
      if((this.filesTotal - skipIndex) > 0) {
        axios
            .get('/fileserver/search?status=' + this.getFileType + '&skipIndex=' + (typeof skipIndex == 'undefined' ? '0' : skipIndex) + '&sortByScore=true')
            .then((res) => {
              let likedItems = localStorage.getItem('kMlI');
              let itemsArr;
              if(likedItems != null) {
                itemsArr = JSON.parse(likedItems);
                res.data.forEach((item) => {
                  if(itemsArr.includes(item._id)) {
                    item.liked = true;
                  }
                });
              }
              if(skipIndex == 0 || typeof skipIndex == 'undefined') {
                this.images = res.data;
              } else {
                this.images = [...this.images, ...res.data];
              }
              this.lightboxItems = this.images.map((e) => {
                return { src: '/files/' + e._id + '/small', title: e.title };
              });
            })
      }
    },
    getTotalCountOfFiles() {
      axios
          .get("/fileserver/total?status=" + this.getFileType)
          .then((res) => {
            this.filesTotal = res.data;
            this.getFiles(0);
          })
          .catch(() => {});
    },
    infiniteHandler($state) {
      this.busy = true;
      if(this.filesTotal - (this.lastSkipIndex -1) > 0) {
        this.lastSkipIndex = this.lastSkipIndex + 12;
        this.getFiles(this.lastSkipIndex);
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    sendLike(fileID, index) {
      let likedItems = localStorage.getItem('kMlI');
      let likebox = 'likebox' + index;
      let itemsArr;

      let sendLike = (fileID2, storageItem) => {
        axios
          .get("/fileserver/like?fileID=" + fileID2)
          .then(() => {
            localStorage.setItem('kMlI', storageItem);
            this.$refs[likebox].classList.add('liked');
            this.images[index].score++;
          })
          .catch(() => {});
      }

      if(likedItems == null) {
        likedItems = JSON.stringify([fileID]);
        sendLike(fileID, likedItems);
      } else {
        itemsArr = JSON.parse(likedItems);
        if(!itemsArr.includes(fileID)) {
          itemsArr.push(fileID);
          likedItems = JSON.stringify(itemsArr);
          sendLike(fileID, likedItems);
        }
      }
    },
  },
  computed: {
    getFileType() {
      return this.site == 'eigene-werke' ? 'intern' : this.site == 'teilnehmer-werke' ? 'extern' : false;
    },
    getColor() {
      switch (this.site) {
        case 'homepage':
          return '#930023';
        case 'eigene-werke':
          return '#8970ea';
        case 'teilnehmer-werke':
          return '#1289A7';
        case 'about':
          return '#e28e18';
        case 'videos':
          return '#A3CB38';
        case 'impressum':
          return '#c44569';
        default:
          return '#c44569';
      }
    }
  },
  beforeMount() {
    this.windowWidth = window.innerWidth;
    this.getCourses();
    this.getRandomImages('extern');
    this.getVideoCount();
  },
  beforeUnmount() {
    clearInterval(this.sliderInterval);
  },
  mounted() {
    window.addEventListener('resize', (e) => {
      this.windowWidth = e.target.innerWidth;
      if(this.windowWidth <= 400) {
        this.renderedGridWidth = this.windowWidth * .95;
      } else if(this.windowWidth <= 1024) {
        this.renderedGridWidth = this.windowWidth * .31;
      } else {
        this.renderedGridWidth = 1140 * .24;
      }
    });
    window.addEventListener('scroll', () => {
      if(window.scrollY >= 300) {
        this.toTopActive = true;
      } else {
        this.toTopActive = false;
      }
    });
    if(this.site == 'eigene-werke' || this.site == 'teilnehmer-werke') {
      this.getTotalCountOfFiles();
      this.lastSkipIndex = 0;
    }
    if (this.site == 'videos') this.getVideos();
    this.sliderInterval = setInterval(() => {
      this.toggleImage();
    }, 7000);
    this.sliderInterval = setInterval(() => {
      this.toggleFile();
    }, 12000);
  },
  watch: {
    site(newValue) {
      if(newValue == 'eigene-werke' || newValue == 'teilnehmer-werke') {
        this.getTotalCountOfFiles();
        this.lastSkipIndex = 0;
      }
      if (newValue == 'videos') this.getVideos();
    }
  }
}
</script>

<style lang="scss">
.like-box {
  svg {
    stroke: #6366f1;
  }
  &.liked {
    svg {
      stroke: #fff;
      transform: scale(1.1);
      .heart {
        fill: #818cf8;
      }
    }
    &:hover {
      svg {
        stroke: #fff;
        transform: scale(1.25);
        .heart {
          fill: #818cf8;
        }
      }
    }
  }
  &:hover {
    div {
      right: 85%;
      opacity: 100%;
    }
    svg {
      transform: scale(1);
      .heart {
        fill: #c4b5fd;
      }
    }
  }
}
.white-gradient {
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.7) 30%, rgba(255,255,255,0.1) 100%);
}
@media (min-width: 768px) {
  .white-gradient {
    background: linear-gradient(90deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 85%);
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.slide-enter-from,
.slide-leave-to {
  opacity: 0;
}

.expand-enter-active,
.expand-leave-active {
  transition: height 150ms ease-in-out;
  overflow: hidden;
}
.expand-enter,
.expand-leave-to {
  height: 0;
}
.pic {
  -webkit-animation:pop-in 350ms;
  -moz-animation:pop-in 350ms;
  -ms-animation:pop-in 350ms;
}
@-webkit-keyframes pop-in {
  0% { opacity: 0; -webkit-transform: scale(0.5); }
  100% { opacity: 1; -webkit-transform: scale(1); }
}
@-moz-keyframes pop-in {
  0% { opacity: 0; -moz-transform: scale(0.5); }
  100% { opacity: 1; -moz-transform: scale(1); }
}
@keyframes pop-in {
  0% { opacity: 0; transform: scale(0.5); }
  100% { opacity: 1; transform: scale(1); }
}
</style>
